import Konva from 'konva';

/**
 * LVGL's widget draw mask is the widget's own rectangular coords.  Padding
 * changes the geometry drawn inside that rectangle; it does not enlarge the
 * area in which the widget may paint.
 */
export function contentClipRect(width, height) {
  return {
    x: 0,
    y: 0,
    width: Math.max(0, Number(width) || 0),
    height: Math.max(0, Number(height) || 0),
  };
}

export function applyContentClip(group, width, height) {
  if (!group) return false;
  const rect = contentClipRect(width, height);
  group.setAttrs({
    clipX: rect.x,
    clipY: rect.y,
    clipWidth: rect.width,
    clipHeight: rect.height,
  });
  return rect;
}

/**
 * Create the private render group used by widgets whose LVGL implementation
 * draws internal content with the widget draw mask (gauge and linemeter).
 * The widget itself, its selection hit area and its layer-level Transformer
 * remain outside this group.
 */
export function createContentClipGroup(owner) {
  const group = new Konva.Group({
    x: 0,
    y: 0,
    listening: true,
  });
  applyContentClip(group, owner.width(), owner.height());
  owner.add(group);
  const sync = () => applyContentClip(group, owner.width(), owner.height());
  owner.on('widthChange heightChange', sync);
  return group;
}

